import { Component } from '@angular/core';

@Component({
  selector: 'app-section-incube-sua-empresa',
  templateUrl: './section-incube-sua-empresa.component.html',
  styleUrls: ['./section-incube-sua-empresa.component.scss']
})
export class SectionIncubeSuaEmpresaComponent {

}
